module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "389",
      "src": "images/f0013-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("BRIGHTY’S WORLD")])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A")])]), _vm._v(" SHAGGY young\n            burro lay asleep in the gray dust of the canyon trail. Except for the slow heaving of\n            his sides and an occasional flick of an ear, he seemed part of the dust and the ageless\n            limestone that rose in great towering battlements behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sun had been shining fiercely on his belly and now began climbing up\n            over his sides, then slowly up the canyon wall. But for a long time the rocks held their\n            heat and the solitary figure dozed on.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("A ground squirrel peered out from a chink in the wall, watching a moment\n            with friendly eyes, then dived back where it came from. A cottontail rabbit played hop,\n            skip, and jump around ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("him. But nothing disturbed the little gray\n            lump, not even a nuthatch hammering away at a juniper tree.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the wind, an uprising current of wind from the depths of the\n            canyon, that finally aroused him. It whirled up his nose and down his ears, tickling him\n            awake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a grunting sigh he began rolling, and with each turn just missed\n            falling off his ledge into Bright Angel Creek, hundreds of feet below. Now he sat up on\n            his haunches, squirming his back against the rough, warm limestone. He gave a luxurious\n            yawn and gazed at the opposite wall as if in search of some creature like himself. But\n            there was only rock, rising sheer and lonely to the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stretched his forelegs and then he was up, shaking the dust from his\n            coat. Over the ledge a few spears of bunch grass grew in a crevice. He leaned out into\n            space and cropped them, jaws swinging sideways as he chewed, while his eyes, from under\n            their thatched roof of hair, looked out over his world. It was a world of rock piled up\n            and up, layer on layer to the sky, and down and down to the Colorado River far\n            below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly, as if balancing the weight of his great ears, the little fellow\n            swung his head around to follow the winding river. His eyes suddenly fixed on a tiny\n            white spot, and at sight of it he opened wide his jaws, swelled out his nostrils, and\n            began braying: “"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Yeeee-aw—yee-aw!\n            Yee-a-a-aw!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instantly the canyon took up the cry. South wall to north and back again\n            it banged and bounced the bray until there was nothing left of it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The burro waited, listening. His ears probed the white spot as if to pull\n            something out of it. There it was! An answering ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("sound! A bellowing\n            halloa, almost as big and brassy as his own. It set the little burro into action.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Down the trail he plunged, zigzagging from ledge to ledge, ears flopping,\n            tail swinging, hoofs toe-dancing the narrow path. Once on his way, a kind of momentum\n            took hold of him and he fairly flew, rounding one cliff only to face another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time and again he crossed Bright Angel Creek, a foaming mountain stream\n            that tumbled downward to the river. For yards and yards he walked in its bed, picking\n            his way around the glossy boulders. But he neither drank nor played in the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only once did he stop to study his goal. The white spot had grown to a\n            tent, and nearby, campfire smoke was curling upward. Satisfied, he plunged on again,\n            always traveling within sight and sound of the busy creek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The afternoon was late and purple shadows were spilling down the canyon\n            walls when he came at last upon the source of the smoke. An old, old prospector with\n            flowing white hair was piling driftwood on a fire. And beside the fire stood an iron\n            skillet and a bowl of yellow batter.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "345",
      "src": "images/f0015-01.jpg",
      "width": "500"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0